import React from 'react';

const ReferralProgram = ({ setCurrentView }) => (
    <div id="referralProgramView" className="info-container">
        <h2>Реферальная программа</h2>
        <p>Уважаемые пользователи, наша реферальная программа находится в активной разработке. Мы работаем над тем, чтобы предложить вам выгодные условия и возможности для заработка, приглашая новых клиентов.</p>
        <p>Следите за новостями! Мы скоро объявим о запуске реферальной программы и всех её деталях.</p>
        <button type="button" onClick={() => setCurrentView('mainMenu')}>Назад в главное меню</button>
    </div>
);

export default ReferralProgram;